import React from 'react';
import headerStyles from './header.module.pcss';
import { MessageProperties } from '../../../../types';

interface HeaderProps {
  messages: MessageProperties;
}

function Header({ messages }: HeaderProps): React.ReactElement {
  const {
    spellingSuggestionHeadingText,
    spellingSuggestionResultText,
    searchResultText,
    suggestion,
    query,
    resultsLength
  } = messages;

  return (
    <div className={headerStyles.header}>
      {suggestion ? (
        <>
          <h2
            className={headerStyles['header__spelling-suggestion-heading']}
            dangerouslySetInnerHTML={{ __html: spellingSuggestionHeadingText }}
          />
          <p className={headerStyles.header__span}>{spellingSuggestionResultText}</p>
          <h3 className={headerStyles.header__query}>
            {suggestion}
            <span className={headerStyles.header__results}> {resultsLength}</span>
          </h3>
        </>
      ) : (
        <>
          <p className={headerStyles.header__span}>{searchResultText}</p>
          <h3 className={headerStyles.header__query}>
            {query}
            <span className={headerStyles.header__results}> {resultsLength}</span>
          </h3>
        </>
      )}
    </div>
  );
}

export default Header;
